<!--
 * @Author: your name
 * @Date: 2022-06-09 11
-->
<!-- 维修视频 -->
<template>
	<div class="brand-story">
		<!-- banner -->
		<div class="banner">
			<img class="bannerImgText" :class="{'act-showsq':actShow}" src="~@/assets/img/brand-culture/story-text.png" alt="" />
			<img class="bannerImg" src="~@/assets/img/brand-culture/story-bg.jpg" alt="" />
		</div>
		<!-- 导航 -->
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane :label="item.label" :name="item.name" v-for="(item, idx) in baseTabs.list" :key="idx" >
				<!-- 标题 -->
				<second-title
					:englithTitle="item.englithTitle"
					:englithA="item.englithA"
					:changname="item.changname"
					:addone="item.addone"
					:addtow="item.addtow"
				></second-title>
			</el-tab-pane>
		</el-tabs>
		<router-view></router-view>
	</div>
</template>
<script>
import SecondTitle from "@/components/SecondTitle";
export default {
    components: { SecondTitle },
    data() {
			return {
				actShow:false,
				activeName: "culture",
				baseTabs: {
						list: [
								{
									id:0,
									label: "品牌文化",
									name: "culture",
									englithTitle: "rand Culture",
									englithA: "B",
									changname: "品牌文化",
									addone: "品牌故事",
									addtow: "品牌文化",
									path:'/brand-culture'
								},
								{
									id:1,
									label: "匠心故事",
									name: "originality",
									englithTitle: "rand Culture",
									englithA: "B",
									changname: "匠心故事",
									addone: "品牌故事",
									addtow: "匠心故事",
									path:'/originality-story'
								},
								{
									id:2,
									label: "品牌历程",
									name: "course",
									englithTitle: "rand Culture",
									englithA: "B",
									changname: "品牌历程",
									addone: "品牌故事",
									addtow: "品牌历程",
									path:'/brand-history'
								},
						],
				},
			};
    },
		created(){
			if (this.$route.path == "/brand-story") {
				this.$router.push('/brand-culture')
			}
			this.baseTabs.list.forEach((item,idx) => {
				if (item.path == this.$route.path) {
					this.activeName = item.name
				}
			});
			setTimeout(() => {
				this.actShow = true
			}, 500);
  	},
    methods: {
			handleClick(tab, event){
				this.baseTabs.list.forEach((item,idx) => {
					if (tab.index == item.id) {
						this.$router.push(item.path)
					}
				});
			}
    },
};
</script>
<style lang="scss">
.brand-story{
		// max-width: 1920px;
		width: 100%;
		margin: 0 auto;
    background: url("../../assets/img/news/bg-1.jpg") no-repeat center;
    background-size: cover;
    .banner {
        width: 100%;
        height: 650px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .bannerImgText{
            position:absolute;
            opacity: 0;
            transition: 1.5s;
            bottom: 20px;

        }
				.act-showsq{
						opacity: 1;
						bottom: 30%;
				}
        .bannerImg {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .el-tabs__nav-wrap::after {
        height: 0px;
    }
    .el-tabs__nav-scroll {
        background-color: #EEC20A;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-tabs__nav {
            display: flex;
            justify-content: space-between;
            width: 600px;
            .el-tabs__active-bar {
                height: 0px;
            }
            .el-tabs__item {
                padding: 0 20px;
                font-size: 16px;
                color: rgb(255, 255, 255);
            }
            .el-tabs__item.is-active {
                color: #000;
                font-weight: 800;
            }
            .el-tabs__item:hover {
                color: #000;
                font-weight: 800;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/brand-story/brand-story.vue